import { OBJECT_CATEGORIES } from '@/domains/partners/multisport/const/ObjectCategories.const'

export const useObjectCategories = () => {
  const { t } = useI18n()
  return OBJECT_CATEGORIES.map(
    (objectCategory: { value: string; text: string }) => ({
      value: t(objectCategory.value),
      text: t(objectCategory.text),
    }),
  )
}
